"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_redux_1 = require("react-redux");
var TypeformPopupButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TypeformPopupButton"));
var Text_1 = __importDefault(require("shared/components/Text"));
var analytics_1 = require("utils/analytics");
var processExpenditures_1 = require("utils/processExpenditures");
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var SaaSAuditSurvey = function (_a) {
    var fullWidthBtn = _a.fullWidthBtn;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var currency = (company === null || company === void 0 ? void 0 : company.baseCurrency) || 'AUD';
    var serviceStats = (0, react_redux_1.useSelector)(ordered_1.selectServiceStats);
    var annualSpend = (0, processExpenditures_1.calculateTotalAnnualSpend)(serviceStats || []);
    var track = (0, analytics_1.usePreparedTracker)('SaaS Audit');
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption" }, { children: "Thank you! In the meanwhile, complete this quick form to helps us understand better how you manage your stack." })), (0, jsx_runtime_1.jsx)(TypeformPopupButton_1.default, __assign({ typeFormID: "cu3ZMacf", color: "secondary", fullWidth: fullWidthBtn, sx: { my: 2, color: 'common.white' }, hidden: {
                    user_id: profile.id,
                    username: (0, end2end_1.getDisplayName)(profile),
                    email: profile === null || profile === void 0 ? void 0 : profile.email,
                    company: company === null || company === void 0 ? void 0 : company.name,
                    companyId: profile === null || profile === void 0 ? void 0 : profile.companyId,
                    annualspend: annualSpend.toLocaleString('en-AU', { style: 'currency', currency: currency }),
                }, 
                // ToDo: make sure this actually works
                onReady: function () { return track({ action: 'Typeform Filled' }); } }, { children: "Take survey" }))] }));
};
exports.default = SaaSAuditSurvey;
